
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign/mfa",
      function () {
        return require("private-next-pages/sign/mfa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign/mfa"])
      });
    }
  